import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ModalStateService {
  private readonly MODAL_SHOWN_KEY = 'modal_image_shown';

  constructor() {}

  /**
   * Check if the modal has been shown in the current session
   */
  hasModalBeenShown(): boolean {
    return sessionStorage.getItem(this.MODAL_SHOWN_KEY) === 'true';
  }

  /**
   * Check if the modal should be shown based on date/time restrictions
   */
  shouldShowModal(): boolean {
    const now = new Date();
    const cutoffDate = new Date(2025, 7, 21, 16, 0, 0); // August 21, 2025 at 19:00 (month is 0-indexed)
    return now < cutoffDate;
  }

  /**
   * Check if the modal can be displayed (combines session and date checks)
   */
  canShowModal(): boolean {
    return !this.hasModalBeenShown() && this.shouldShowModal();
  }

  /**
   * Mark the modal as shown in the current session
   */
  markModalAsShown(): void {
    sessionStorage.setItem(this.MODAL_SHOWN_KEY, 'true');
  }

  /**
   * Reset the modal state (useful for testing or manual reset)
   */
  resetModalState(): void {
    sessionStorage.removeItem(this.MODAL_SHOWN_KEY);
  }
}
